import type { BriefingsAboutData } from "./fetchers/briefingsAboutFetcher";
import HeaderSection from "./components/headerSection/headerSection";
import VideoSection from "./components/videoSection/videoSection";
import SectionPromo from "./components/sectionPromo/sectionPromo";

type BriefingsViewProps = BriefingsAboutData;

const BriefingsAboutView = (props: BriefingsViewProps) => {
  return (
    <main className={"pt-[50px] lg:pt-[70px]"}>
      <section className={"bg-[#F4F4F6]"}>
        <div className="max-w-[1140px] px-5 md:mx-auto lg:max-w-[1220px] lg:px-0">
          <HeaderSection
            primaryCtaLabel={props.primaryCtaLabel}
            primaryCtaUrl={props.primaryCtaUrl}
            title={props.title}
            marketingPoints={props.marketingPoints}
            marketingPointsHeading={props.marketingPointsHeading}
            secondaryButtonLabel={props.secondaryButtonLabel}
            secondaryButtonUrl={props.secondaryButtonUrl}
          />
        </div>
      </section>
      {(props.video || props.videoHeading || props.videoParagraph) && (
        <section className={"bg-[#E9E9EB]"}>
          <div className="max-w-[1140px] px-5 md:mx-auto lg:max-w-[1220px] lg:px-0">
            <VideoSection
              video={props.video}
              videoHeading={props.videoHeading}
              videoParagraph={props.videoParagraph}
            />
          </div>
        </section>
      )}
      <section className={"bg-[#F4F4F6]"}>
        <SectionPromo {...props} />
      </section>
    </main>
  );
};

export default BriefingsAboutView;
